import { IconButton, Tooltip } from "@material-ui/core";

import { Fragment } from "react";
import InfoIcon from "@material-ui/icons/Info";

export default function InfoMaps() {
    return (
        <Tooltip
            arrow
            placement="top"
            title={
                <Fragment>
                    Para obtener su enlace de ubicación:
                    <br />
                    1. Ingrese a maps.google.com.mx
                    <br />
                    2. Localice la ubicación de su consultorio
                    <br />
                    3. Seleccione Compartir del ménu lateral izquierdo
                    <br />
                    4. Seleccione en Copiar Vínculo y pegue la url compartida
                </Fragment>
            }
        >
            <IconButton>
                <InfoIcon />
            </IconButton>
        </Tooltip>
    );
}
